// Chat is open to EVERY authenticated user of this app: the tester email allowlist was
// removed from this predicate (ACH-8da.31, 2026-09-10) now that agent chat has shipped to
// all internal users. The server is the enforcement — ACH's agent-chat handlers require an
// authenticated, internal, authorized caller and refuse anyone else — so the only
// client-side scoping left is the build flag and the route: public routes render outside
// ProtectedRoute, so there is no authenticated caller to chat as.
// The allowlist mechanism itself (achTesterEligible / VITE_ACH_TESTER_EMAILS in
// src/util/apiHostFor.ts) is deliberately RETAINED — it is the lever that will gate the
// WRITE flip — it simply no longer gates chat.
// Its own module because ChatEntry has to answer "is chat on here?" *before* it dynamically
// imports the chat bundle — importing ChatDrawer to ask would defeat the split.

import { isPublicPath } from './pageContext';

export const agentChatEnabled = (params: { envFlag: string | undefined; pathname: string }): boolean => {
  const { envFlag, pathname } = params;
  return envFlag === 'true' && !isPublicPath(pathname);
};

export default agentChatEnabled;
